
<div class="md:w-368 mx-auto">
  <JobPostScheduleCard
    id="schedule-type-occasional"
    title="Occasional sitter"
    body="As-needed for when you need care"
    :shadow="false"
    class="mb-16"
  >
    <OccasionalScheduleIcon />
  </JobPostScheduleCard>
  <Card class="w-full md:p-24">
    <form>
      <div class="mb-32">
        <poppins-date-picker
          id="occasional-schedule-datepicker"
          v-model="startDate"
          labelName="Start date"
          :minDate="minStartDate"
          :maxDate="maxStartDate"
          :status="helperStatus"
          :helperText="errors.startDate"
          class="mb-16"
          @input="$delete(errors, 'startDate')"
        />
        <Checkbox v-model="startDateFlexible" labelName="Start date is flexible" checkboxId="start-date-flexible" />
      </div>
      <div class="flex flex-row-reverse">
        <RouteStepperNextButton
          :stepData="reviewSection"
          :draftData="scheduleData"
          :validate="validate"
          @errors="errors = $event"
        />
      </div>
    </form>
  </Card>
</div>
